import { createAxiosHttp } from "./createHttpRequest";

type IResult<T> = {
  code: number;
  message?: string;
  data: T
}

// 签名状态
export enum SignState {
  // 0未签名
  None,
  // 1是医生
  Doctor,
  // 2是患者
  Examinee,
  // 3是都签名
  All
}

export type SignAgreementResult = {
  agreement: string;
  allocationCode: unknown | null;
  centerCode: string;
  code: string;
  createTime: string;
  createUser: string;
  hasScreen: unknown | null;
  icon: string;
  id: number | null;
  joinDate: string;
  projectCode: string;
  state: number;
  // 1线上知情，2线下知情
  informed: number;
  signatureState: SignState,
}

// 根据code查询签署模板信息
export const signAgreementQuery = (subjectCode: string, fromDoctor=false)=> {
  return createAxiosHttp<IResult<SignAgreementResult>>({
    url: `data/subject/signAgreementQuery/${subjectCode}?judgment=${fromDoctor ? 1 : 2}`,
  })
}

// 受试者扫码绑定操作
export const subjectScanCodeBinding = (subjectCode: string, doctorName: string)=> {
  return createAxiosHttp<IResult<any>>({
    url: '/data/report/subject/scancode/binding',
    method: 'post',
    data: {
      subjectCode,
      doctorName
    }
  })
}

// 石药多恩达自定义表单 - 添加表单
type Payload = {
  visitId: number
  templateId: number
  name: string
}
export const addCustomForm = ({visitId, ...data}: Payload)=> {
  return createAxiosHttp<IResult<any>>({
    method: 'post',
    url: `data/form/add/${visitId}`,
    data,
  })
}

export const formForbidden = (formId: number)=> {
  return createAxiosHttp<IResult<any>>({
    method: 'get',
    url: `data/form/forbidden/${formId}`
  })
}


interface SumCountRecord {
  allCount: number
  groupNum: number
  questionNum: number
}

/**
 * 君实统计
 * @returns 
 */
export const getSumCount = async()=> {
  return createAxiosHttp<IResult<SumCountRecord>>({
    method: 'post',
    url: 'data/getSumCount',
  })
}

// 汉字转拼音
export const getAbbreviation = (name: string)=> {
  return createAxiosHttp<IResult<string>>({
    url: `data/subejct/name/abbreviation?name=${name}`
  })
}

// 撤回锁定
export const unlockForm = (formId: number)=> {
  return createAxiosHttp<IResult<string>>({
    url: `data/form/unlock/${formId}`
  })
}